.formWeightsButtonContainer {
  width: 45%;
  flex-grow: 1;
}
